import { StrictMode, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider, helmetContext } from './utils/helmet';
import App from './App.tsx';
import './index.css';
import { initPerformanceTracking } from './utils/performanceTracking';

// Define the main component with performance monitoring
function Root() {
  // Initialize performance tracking
  useEffect(() => {
    // Mark the initial load time for reference
    if (window.performance) {
      const timeToFirstRender = performance.now();
      console.log('Time to first render:', Math.round(timeToFirstRender), 'ms');
    }
    
    // Initialize performance tracking and cleanup on unmount
    const cleanup = initPerformanceTracking();
    return cleanup;
  }, []);

  return (
    <StrictMode>
      <HelmetProvider context={helmetContext}>
        <App />
      </HelmetProvider>
    </StrictMode>
  );
}

// Create root with options focused on speed
const rootElement = document.getElementById('root');

// Remove loading state immediately before React hydrates
const loadingContainer = document.querySelector('.loading-container');
if (loadingContainer) {
  // Keep loading heading until React hydrates
  const mainHeading = document.querySelector('.main-heading');
  if (mainHeading) {
    rootElement?.appendChild(mainHeading.cloneNode(true));
  }
  
  // Fade out loading indicator
  loadingContainer.classList.add('fade-out');
  setTimeout(() => {
    loadingContainer.remove();
  }, 500);
}

// Enable concurrent mode for better responsiveness
createRoot(rootElement!).render(<Root />);
